module.exports = __webpack_public_path__ + "static/media/ideas.5809706b.bin";